import { StoreImageTypes } from '../storeImage.type';

export enum PromotionDisplayExternalType {
  LOCAL = 'LOCAL',
  EXTERNAL_OPTINMONSTER = 'EXTERNAL_OPTINMONSTER',
}

export interface PromotionsTypes {
  id: number;
  code: string;
  title: string;
  description?: string;
  type: string;
  image?: StoreImageTypes;
  url?: string;
  parentCode?: string;
  formType?: string;
  buttonName?: string;
  shortDescription?: string;
  externalScript?: string;
  displayExternalType?: PromotionDisplayExternalType;
}

export interface PromotionDisplayTypes {
  [key: string]: PromotionsTypes[];
}

export interface PromotionResponseTypes {
  id: number;
  code: string;
  name: string;
  displays?: PromotionDisplayTypes;
}

export interface PromotionSubmitFormTypes {
  fromUrl: string;
  email?: string;
  phoneNumber?: string;
  positionPromotion: string;
  promotion: string;
}

export interface PromotionDataFormTypes {
  email?: string;
  phoneNumber?: string;
  formType: string;
  title: string;
  type: string;
  code: string;
  emailPhone?: string;
}
